import React from 'react';
import './TermsModal.css';

interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const TermsModal: React.FC<TermsModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="terms-modal-overlay" onClick={onClose}>
      <div className="terms-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="terms-modal-header">
          <h2>Kullanım Şartları</h2>
          <button className="terms-modal-close" onClick={onClose}>
            <i className="bi bi-x-lg"></i>
          </button>
        </div>

        <div className="terms-modal-body">
          <div className="terms-section">
            <h3>1. Genel Hükümler</h3>
            <p>
              Bu web sitesi <strong>Karadaş Hukuk Bürosu</strong> tarafından işletilmektedir.
              Sitemizi kullanarak aşağıdaki şartları kabul etmiş sayılırsınız.
            </p>
          </div>

          <div className="terms-section">
            <h3>2. Hizmet Kapsamı</h3>
            <p>
              Web sitemiz üzerinden sunulan hizmetler yalnızca <strong>bilgilendirme amaçlıdır</strong>.
              Sitedeki içerikler genel hukuki bilgi sağlamak için hazırlanmış olup, özel durumunuza
              yönelik hukuki tavsiye niteliğinde değildir.
            </p>
            <p>
              Profesyonel hukuki danışmanlık için lütfen bizimle doğrudan iletişime geçin.
            </p>
          </div>

          <div className="terms-section">
            <h3>3. Kullanıcı Hesapları</h3>
            <ul>
              <li>Kayıt sırasında verdiğiniz bilgilerin doğru ve güncel olması gerekmektedir.</li>
              <li>Hesap güvenliği kullanıcının sorumluluğundadır. Şifrenizi kimseyle paylaşmayın.</li>
              <li>Hesabınızdan gerçekleşen tüm işlemlerden siz sorumlusunuz.</li>
              <li>Yetkisiz erişim veya güvenlik ihlali durumunda derhal bize bildirin.</li>
            </ul>
          </div>

          <div className="terms-section">
            <h3>4. Gizlilik ve Kişisel Veriler</h3>
            <p>
              Kişisel verileriniz <strong>6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK)</strong>
              kapsamında işlenmektedir. Verileriniz:
            </p>
            <ul>
              <li>Hukuki hizmet sunumu ve müvekkil iletişimi için kullanılır</li>
              <li>Üçüncü şahıslarla paylaşılmaz (yasal zorunluluk hariç)</li>
              <li>SSL şifreleme ile korunur</li>
              <li>İzin verdiğiniz süre boyunca saklanır</li>
            </ul>
          </div>

          <div className="terms-section">
            <h3>5. Fikri Mülkiyet Hakları</h3>
            <p>
              Bu web sitesindeki tüm içerik (metin, görsel, logo, tasarım, kod)
              <strong> Karadaş Hukuk Bürosu'na</strong> aittir ve telif hakkı yasaları ile korunmaktadır.
            </p>
            <p>
              İçeriklerin izinsiz kopyalanması, çoğaltılması veya dağıtılması yasaktır.
            </p>
          </div>

          <div className="terms-section">
            <h3>6. Yasaklanan Davranışlar</h3>
            <p>Sistemimizi kullanırken aşağıdaki davranışlar yasaktır:</p>
            <ul>
              <li>Hukuka aykırı, zararlı veya yanıltıcı içerik paylaşmak</li>
              <li>Başkasının kimliğine bürünmek veya yetkisiz erişim sağlamak</li>
              <li>Virüs, zararlı yazılım veya spam göndermek</li>
              <li>Sistem güvenliğini tehdit etmek veya aşırı yük oluşturmak</li>
              <li>Diğer kullanıcıları rahatsız etmek veya taciz etmek</li>
            </ul>
          </div>

          <div className="terms-section">
            <h3>7. Sorumluluk Sınırlamaları</h3>
            <ul>
              <li>Site kesintisiz veya hatasız çalışma garantisi vermez</li>
              <li>Üçüncü taraf web sitelerine verilen linklerden sorumlu değiliz</li>
              <li>Kullanıcı kaynaklı veri kayıplarından sorumlu tutulamayız</li>
              <li>Sitedeki bilgilerin güncelliğini garanti edemeyiz</li>
            </ul>
          </div>

          <div className="terms-section">
            <h3>8. Hesap İptali</h3>
            <p>
              Kullanım şartlarını ihlal eden kullanıcıların hesapları önceden bildirim
              yapılmaksızın askıya alınabilir veya iptal edilebilir.
            </p>
          </div>

          <div className="terms-section">
            <h3>9. Şartların Değiştirilmesi</h3>
            <p>
              Karadaş Hukuk Bürosu bu kullanım şartlarını dilediği zaman değiştirme hakkını saklı tutar.
              Değişiklikler sitede yayınlandığı anda yürürlüğe girer.
            </p>
          </div>

          <div className="terms-section">
            <h3>10. İletişim</h3>
            <p>
              Kullanım şartları hakkında sorularınız için:
            </p>
            <ul>
              <li><strong>E-posta:</strong> sinansakitkaradas@gmail.com</li>
              <li><strong>Telefon:</strong> +90 555 085 79 71</li>
              <li><strong>Adres:</strong> Necmettin Erbakan Mahallesi, Onur Sokak, NO:4, Daire: 15, Beşevler Rezidans, MERKEZ/KİLİS</li>
            </ul>
          </div>

          <div className="terms-section">
            <h3>11. Uygulanacak Hukuk</h3>
            <p>
              Bu sözleşmeden doğabilecek uyuşmazlıklarda <strong>Türkiye Cumhuriyeti yasaları</strong> uygulanır.
            </p>
          </div>

          <div className="terms-footer">
            <p><strong>Son Güncelleme:</strong> 12 Mayıs 2026</p>
            <p><strong>Yürürlük Tarihi:</strong> 12 Mayıs 2026</p>
          </div>
        </div>

        <div className="terms-modal-footer">
          <button className="terms-accept-button" onClick={onClose}>
            Anladım
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;
